"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";

const SuperOfferModal = dynamic(() => import("./SuperOfferModal"), {
  ssr: false,
});

interface Props {
  companyId: string;
  domain: string;
  pageKey?: string;
}

const LazySuperOfferModal = (props: Props) => {
  const [canLoad, setCanLoad] = useState(false);

  useEffect(() => {
    const trigger = () => {
      setCanLoad(true);
      window.removeEventListener("scroll", trigger);
      window.removeEventListener("touchstart", trigger);
      window.removeEventListener("mousemove", trigger);
    };

    window.addEventListener("scroll", trigger, { passive: true, once: true });
    window.addEventListener("touchstart", trigger, { passive: true, once: true });
    window.addEventListener("mousemove", trigger, { passive: true, once: true });

    const timer = setTimeout(trigger, 6000);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", trigger);
      window.removeEventListener("touchstart", trigger);
      window.removeEventListener("mousemove", trigger);
    };
  }, []);

  if (!canLoad) return null;

  return <SuperOfferModal {...props} />;
};

export default LazySuperOfferModal;
